var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 0 23 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80BEB5",
    d: "M5.96 6.29c3.01-2.91 7.7-3.48 11.8-.6 4.08 2.9 7.91 11.77 4.9 14.68-3.02 2.91-13.06 1.61-16.88-2.35-3.82-3.95-2.84-8.82.18-11.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M8.85 19.34H7.46c-1 0-1.81-.81-1.81-1.82V6.86c0-1 .8-1.82 1.81-1.82h13.87c1 0 1.82.81 1.82 1.82v10.66c0 1-.82 1.82-1.82 1.82H14.1l-4.06 3.05a.75.75 0 0 1-1.2-.6v-2.45zm1.5.95L13.4 18c.13-.1.29-.15.45-.15h7.47c.17 0 .32-.14.32-.32V6.86a.32.32 0 0 0-.32-.32H7.46a.32.32 0 0 0-.31.32v10.66c0 .18.14.32.31.32H9.6c.41 0 .75.34.75.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M9.6 11.34h9.6a.75.75 0 0 0 0-1.5H9.6a.75.75 0 0 0 0 1.5m0 3.2h7.46a.75.75 0 0 0 0-1.5H9.6a.75.75 0 0 0 0 1.5"
  })));
};
export default SvgChat;